// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* App.css */
body{
  margin: 0;
  padding: 0;
  box-sizing: border-box; 
}
.app-container {
  display: flex;
  height: 100vh;
  font-family: Arial, sans-serif;
}

.main-content {
  flex: 1 1;
  position: relative;
  padding: 10px;
  overflow: auto;
}

.open-btn {
  position: fixed;
  top: 10px;
  left: 10px;
  font-size: 24px;
  cursor: pointer;
  z-index: 1000;
}

.dx-datagrid {
  color: #000 !important;
  background-color: #fff !important;
}

.dx-datagrid .dx-row > td {
  color: #000 !important;
}

.dx-datagrid-search-panel input {
  height: 32px !important;
  line-height: 32px !important;   /* height 와 동일하게 */
  font-size: 14px;
  padding: 4px 8px;
  box-sizing: border-box;
}


/* src/index.css 또는 App.css 에 추가하세요 */

/* ----------------------------------------- */
/*     세련된 데이터 그리드 디자인 (추천)      */
/* ----------------------------------------- */

/* 1. 기본 설정: 세로선을 모두 제거하고, 부드러운 가로선만 사용 */
.dx-datagrid-rowsview .dx-datagrid-table .dx-row > td {
  border-bottom: 1px solid #ebebeb; /* 매우 연한 회색으로 선을 부드럽게 */
}
.dx-datagrid-headers .dx-datagrid-table .dx-row > td {
  border-bottom: 2px solid #e0e0e0; /* 헤더의 하단 선은 조금 더 진하게 */
}

/* 모든 세로선 제거 */
.dx-datagrid-rowsview .dx-datagrid-table td.dx-datagrid-cell-vertical-border,
.dx-datagrid-headers .dx-datagrid-table td.dx-datagrid-cell-vertical-border {
  border-left: none;
}


/* 2. 헤더 디자인: 배경색과 폰트로 강조 */
.dx-datagrid-headers .dx-datagrid-table .dx-row > td {
  background-color: #fafafa; /* 밝은 회색 배경 */
  color: #333;              /* 기본보다 약간 진한 텍스트 색상 */
  font-weight: 600;          /* 굵은 글씨체 */
  text-align: center;        /* 헤더 텍스트 중앙 정렬 */
}


/* 3. 가독성을 위한 행 스타일 */

/* 짝수/홀수 행 색상 (Zebra-striping) */
.dx-datagrid-rowsview .dx-datagrid-table .dx-row-alt {
  background-color: #f8f9fa; /* 아주 미세한 색상 차이 */
}

/* 마우스를 올렸을 때(Hover) 부드러운 효과 */
.dx-datagrid-rowsview .dx-datagrid-table .dx-row:not(.dx-row-focused):hover {
  background-color: #e9f5ff; /* 부드러운 하늘색으로 하이라이트 */
  transition: background-color 0.2s ease-in-out;
}


/* 4. 여유 공간 확보: 모든 셀에 충분한 내부 여백 추가 */
.dx-datagrid .dx-datagrid-table .dx-row > td {
  padding: 12px 10px;
}


/* 5. 고정(fixed) 컬럼의 오른쪽 테두리만 살짝 강조 */
.dx-datagrid-rowsview .dx-datagrid-table td.dx-datagrid-fixed-column {
  border-right: 1px solid #e0e0e0;
}
.dx-datagrid-headers .dx-datagrid-table td.dx-datagrid-fixed-column {
  border-right: 1px solid #d3d3d3;
}


/* --- 모든 그리드의 필터 행(Filter Row) 크기 일정하게 맞추기 --- */

/* 1. 필터 셀 내부의 에디터 높이 고정 */
.dx-datagrid-filter-row .dx-editor-container .dx-texteditor {
  height: 32px !important; /* 높이를 32px로 통일 */
  border-radius: 4px !important;
}

/* 2. 필터 입력창 내부 텍스트 위치 보정 */
.dx-datagrid-filter-row .dx-editor-container .dx-texteditor-input {
  min-height: 32px !important;
  padding: 0 8px !important;
  display: flex !important;
  align-items: center !important;
}

/* 3. 필터 왼쪽 돋보기(필터 선택 메뉴) 아이콘 위치 정렬 */
.dx-datagrid-filter-row .dx-editor-with-menu .dx-menu-item-content .dx-icon {
  height: 32px !important;
  line-height: 32px !important;
  display: flex !important;
  align-items: center !important;
}

/* 4. 필터 행 전체의 패딩 조정 (글자가 짤리지 않게) */
.dx-datagrid-filter-row > td {
  padding: 8px 5px !important; /* 위아래 여백을 주어 균형을 맞춤 */
  vertical-align: middle !important;
}

/* 돋보기 메뉴 배경 제거 (깔끔하게 보이기 위함) */
.dx-datagrid-filter-row .dx-menu-item-content {
  padding: 0 4px !important;
}


/* src/index.css 또는 App.css 에 추가 */

/* --- 세련된 로딩 오버레이 스타일 --- */

/* 1. 화면 전체를 덮는 반투명 배경 */
.loading-overlay {
  position: fixed; /* 화면 전체에 고정 */
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* 반투명 검은색 배경 */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999; /* 다른 모든 요소 위에 표시 */
  flex-direction: column; /* 스피너와 텍스트를 세로로 배치 */
  gap: 20px; /* 스피너와 텍스트 사이 간격 */
}

/* 2. CSS 애니메이션을 이용한 스피너 */
.loading-spinner {
  width: 50px;
  height: 50px;
  border: 5px solid #f3f3f3; /* 스피너의 기본 회색 테두리 */
  border-top: 5px solid #3498db; /* 스피너의 파란색 하이라이트 부분 */
  border-radius: 50%;
  animation: spin 1s linear infinite; /* 'spin' 애니메이션을 1초 동안 무한 반복 */
}

/* 3. 로딩 텍스트 스타일 */
.loading-text {
  color: white;
  font-size: 1.2rem;
  font-weight: 500;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
}


/* App.css 맨 아래에 추가 */

/* Lot Summary 전용 격리 스타일 */
.lot-summary-page .section-bar {
  background: #f4f4f4;
  padding: 8px 12px;
  font-weight: bold;
  border-bottom: 1px solid #ddd;
  margin-top: 10px;
  color: #333;
}

/* 콤보박스 내 텍스트 수직 중앙 정렬 수정 */
.lot-summary-page .dx-texteditor-input {
  display: flex !important;
  align-items: center !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  height: 100% !important;
}

/* Bin 상세 헤더: 세로 쓰기 적용 */
.lot-summary-page .vertical-header {
  height: 120px; /* 잘리지 않게 충분한 높이 확보 */
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding-bottom: 8px;
}

.lot-summary-page .vertical-header span {
  writing-mode: vertical-rl;
  transform: rotate(180deg);
  white-space: nowrap;
  font-size: 11px;
  font-weight: 600;
  color: #444;
}

/* 숫자 표시 최적화 */
.lot-summary-page .bin-cell-header {
  font-size: 10px;
  text-align: center;
  font-weight: bold;
}

/* 4. 회전 애니메이션 정의 */
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,YAAY;AACZ;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,UAAU;EACV,eAAe;EACf,eAAe;EACf,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,4BAA4B,IAAI,kBAAkB;EAClD,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;;AAGA,qCAAqC;;AAErC,8CAA8C;AAC9C,kCAAkC;AAClC,8CAA8C;;AAE9C,yCAAyC;AACzC;EACE,gCAAgC,EAAE,uBAAuB;AAC3D;AACA;EACE,gCAAgC,EAAE,uBAAuB;AAC3D;;AAEA,cAAc;AACd;;EAEE,iBAAiB;AACnB;;;AAGA,2BAA2B;AAC3B;EACE,yBAAyB,EAAE,aAAa;EACxC,WAAW,eAAe,sBAAsB;EAChD,gBAAgB,WAAW,WAAW;EACtC,kBAAkB,SAAS,iBAAiB;AAC9C;;;AAGA,qBAAqB;;AAErB,gCAAgC;AAChC;EACE,yBAAyB,EAAE,iBAAiB;AAC9C;;AAEA,8BAA8B;AAC9B;EACE,yBAAyB,EAAE,qBAAqB;EAChD,6CAA6C;AAC/C;;;AAGA,oCAAoC;AACpC;EACE,kBAAkB;AACpB;;;AAGA,oCAAoC;AACpC;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;;;AAGA,iDAAiD;;AAEjD,0BAA0B;AAC1B;EACE,uBAAuB,EAAE,iBAAiB;EAC1C,6BAA6B;AAC/B;;AAEA,2BAA2B;AAC3B;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA,qCAAqC;AACrC;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA,mCAAmC;AACnC;EACE,2BAA2B,EAAE,sBAAsB;EACnD,iCAAiC;AACnC;;AAEA,+BAA+B;AAC/B;EACE,yBAAyB;AAC3B;;;AAGA,kCAAkC;;AAElC,4BAA4B;;AAE5B,wBAAwB;AACxB;EACE,eAAe,EAAE,cAAc;EAC/B,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC,EAAE,eAAe;EACrD,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa,EAAE,mBAAmB;EAClC,sBAAsB,EAAE,qBAAqB;EAC7C,SAAS,EAAE,mBAAmB;AAChC;;AAEA,0BAA0B;AAC1B;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB,EAAE,mBAAmB;EAC9C,6BAA6B,EAAE,sBAAsB;EACrD,kBAAkB;EAClB,kCAAkC,EAAE,8BAA8B;AACpE;;AAEA,kBAAkB;AAClB;EACE,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,2CAA2C;AAC7C;;;AAGA,qBAAqB;;AAErB,0BAA0B;AAC1B;EACE,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,6BAA6B;EAC7B,gBAAgB;EAChB,WAAW;AACb;;AAEA,2BAA2B;AAC3B;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,yBAAyB;EACzB,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA,wBAAwB;AACxB;EACE,aAAa,EAAE,qBAAqB;EACpC,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA,cAAc;AACd;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,mBAAmB;AACnB;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC","sourcesContent":["/* App.css */\nbody{\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box; \n}\n.app-container {\n  display: flex;\n  height: 100vh;\n  font-family: Arial, sans-serif;\n}\n\n.main-content {\n  flex: 1;\n  position: relative;\n  padding: 10px;\n  overflow: auto;\n}\n\n.open-btn {\n  position: fixed;\n  top: 10px;\n  left: 10px;\n  font-size: 24px;\n  cursor: pointer;\n  z-index: 1000;\n}\n\n.dx-datagrid {\n  color: #000 !important;\n  background-color: #fff !important;\n}\n\n.dx-datagrid .dx-row > td {\n  color: #000 !important;\n}\n\n.dx-datagrid-search-panel input {\n  height: 32px !important;\n  line-height: 32px !important;   /* height 와 동일하게 */\n  font-size: 14px;\n  padding: 4px 8px;\n  box-sizing: border-box;\n}\n\n\n/* src/index.css 또는 App.css 에 추가하세요 */\n\n/* ----------------------------------------- */\n/*     세련된 데이터 그리드 디자인 (추천)      */\n/* ----------------------------------------- */\n\n/* 1. 기본 설정: 세로선을 모두 제거하고, 부드러운 가로선만 사용 */\n.dx-datagrid-rowsview .dx-datagrid-table .dx-row > td {\n  border-bottom: 1px solid #ebebeb; /* 매우 연한 회색으로 선을 부드럽게 */\n}\n.dx-datagrid-headers .dx-datagrid-table .dx-row > td {\n  border-bottom: 2px solid #e0e0e0; /* 헤더의 하단 선은 조금 더 진하게 */\n}\n\n/* 모든 세로선 제거 */\n.dx-datagrid-rowsview .dx-datagrid-table td.dx-datagrid-cell-vertical-border,\n.dx-datagrid-headers .dx-datagrid-table td.dx-datagrid-cell-vertical-border {\n  border-left: none;\n}\n\n\n/* 2. 헤더 디자인: 배경색과 폰트로 강조 */\n.dx-datagrid-headers .dx-datagrid-table .dx-row > td {\n  background-color: #fafafa; /* 밝은 회색 배경 */\n  color: #333;              /* 기본보다 약간 진한 텍스트 색상 */\n  font-weight: 600;          /* 굵은 글씨체 */\n  text-align: center;        /* 헤더 텍스트 중앙 정렬 */\n}\n\n\n/* 3. 가독성을 위한 행 스타일 */\n\n/* 짝수/홀수 행 색상 (Zebra-striping) */\n.dx-datagrid-rowsview .dx-datagrid-table .dx-row-alt {\n  background-color: #f8f9fa; /* 아주 미세한 색상 차이 */\n}\n\n/* 마우스를 올렸을 때(Hover) 부드러운 효과 */\n.dx-datagrid-rowsview .dx-datagrid-table .dx-row:not(.dx-row-focused):hover {\n  background-color: #e9f5ff; /* 부드러운 하늘색으로 하이라이트 */\n  transition: background-color 0.2s ease-in-out;\n}\n\n\n/* 4. 여유 공간 확보: 모든 셀에 충분한 내부 여백 추가 */\n.dx-datagrid .dx-datagrid-table .dx-row > td {\n  padding: 12px 10px;\n}\n\n\n/* 5. 고정(fixed) 컬럼의 오른쪽 테두리만 살짝 강조 */\n.dx-datagrid-rowsview .dx-datagrid-table td.dx-datagrid-fixed-column {\n  border-right: 1px solid #e0e0e0;\n}\n.dx-datagrid-headers .dx-datagrid-table td.dx-datagrid-fixed-column {\n  border-right: 1px solid #d3d3d3;\n}\n\n\n/* --- 모든 그리드의 필터 행(Filter Row) 크기 일정하게 맞추기 --- */\n\n/* 1. 필터 셀 내부의 에디터 높이 고정 */\n.dx-datagrid-filter-row .dx-editor-container .dx-texteditor {\n  height: 32px !important; /* 높이를 32px로 통일 */\n  border-radius: 4px !important;\n}\n\n/* 2. 필터 입력창 내부 텍스트 위치 보정 */\n.dx-datagrid-filter-row .dx-editor-container .dx-texteditor-input {\n  min-height: 32px !important;\n  padding: 0 8px !important;\n  display: flex !important;\n  align-items: center !important;\n}\n\n/* 3. 필터 왼쪽 돋보기(필터 선택 메뉴) 아이콘 위치 정렬 */\n.dx-datagrid-filter-row .dx-editor-with-menu .dx-menu-item-content .dx-icon {\n  height: 32px !important;\n  line-height: 32px !important;\n  display: flex !important;\n  align-items: center !important;\n}\n\n/* 4. 필터 행 전체의 패딩 조정 (글자가 짤리지 않게) */\n.dx-datagrid-filter-row > td {\n  padding: 8px 5px !important; /* 위아래 여백을 주어 균형을 맞춤 */\n  vertical-align: middle !important;\n}\n\n/* 돋보기 메뉴 배경 제거 (깔끔하게 보이기 위함) */\n.dx-datagrid-filter-row .dx-menu-item-content {\n  padding: 0 4px !important;\n}\n\n\n/* src/index.css 또는 App.css 에 추가 */\n\n/* --- 세련된 로딩 오버레이 스타일 --- */\n\n/* 1. 화면 전체를 덮는 반투명 배경 */\n.loading-overlay {\n  position: fixed; /* 화면 전체에 고정 */\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5); /* 반투명 검은색 배경 */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 9999; /* 다른 모든 요소 위에 표시 */\n  flex-direction: column; /* 스피너와 텍스트를 세로로 배치 */\n  gap: 20px; /* 스피너와 텍스트 사이 간격 */\n}\n\n/* 2. CSS 애니메이션을 이용한 스피너 */\n.loading-spinner {\n  width: 50px;\n  height: 50px;\n  border: 5px solid #f3f3f3; /* 스피너의 기본 회색 테두리 */\n  border-top: 5px solid #3498db; /* 스피너의 파란색 하이라이트 부분 */\n  border-radius: 50%;\n  animation: spin 1s linear infinite; /* 'spin' 애니메이션을 1초 동안 무한 반복 */\n}\n\n/* 3. 로딩 텍스트 스타일 */\n.loading-text {\n  color: white;\n  font-size: 1.2rem;\n  font-weight: 500;\n  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);\n}\n\n\n/* App.css 맨 아래에 추가 */\n\n/* Lot Summary 전용 격리 스타일 */\n.lot-summary-page .section-bar {\n  background: #f4f4f4;\n  padding: 8px 12px;\n  font-weight: bold;\n  border-bottom: 1px solid #ddd;\n  margin-top: 10px;\n  color: #333;\n}\n\n/* 콤보박스 내 텍스트 수직 중앙 정렬 수정 */\n.lot-summary-page .dx-texteditor-input {\n  display: flex !important;\n  align-items: center !important;\n  padding-top: 0 !important;\n  padding-bottom: 0 !important;\n  height: 100% !important;\n}\n\n/* Bin 상세 헤더: 세로 쓰기 적용 */\n.lot-summary-page .vertical-header {\n  height: 120px; /* 잘리지 않게 충분한 높이 확보 */\n  display: flex;\n  align-items: flex-end;\n  justify-content: center;\n  padding-bottom: 8px;\n}\n\n.lot-summary-page .vertical-header span {\n  writing-mode: vertical-rl;\n  transform: rotate(180deg);\n  white-space: nowrap;\n  font-size: 11px;\n  font-weight: 600;\n  color: #444;\n}\n\n/* 숫자 표시 최적화 */\n.lot-summary-page .bin-cell-header {\n  font-size: 10px;\n  text-align: center;\n  font-weight: bold;\n}\n\n/* 4. 회전 애니메이션 정의 */\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
